"use strict";
window.showMagazine = showMagazine;
window.showModalCover = showModalCover;
function showMagazine() {
    let magazineIframe = document.getElementById("magazineIframe");
    let magazineCover = document.getElementById("magazineCover");
    magazineIframe === null || magazineIframe === void 0 ? void 0 : magazineIframe.classList.remove("d-none");
    magazineIframe === null || magazineIframe === void 0 ? void 0 : magazineIframe.classList.add("d-block");
    magazineCover === null || magazineCover === void 0 ? void 0 : magazineCover.classList.remove("d-flex");
    magazineCover === null || magazineCover === void 0 ? void 0 : magazineCover.classList.add("d-none");
}
function showModalCover(position) {
    let lastCover = document.getElementById("lastCover");
    let antepenulCover = document.getElementById("antepenulCover");
    if (position == 0 && lastCover) {
        lastCover === null || lastCover === void 0 ? void 0 : lastCover.classList.remove('d-none');
        antepenulCover ? antepenulCover === null || antepenulCover === void 0 ? void 0 : antepenulCover.classList.add('d-none') : '';
    }
    if (position == 1 && antepenulCover) {
        antepenulCover === null || antepenulCover === void 0 ? void 0 : antepenulCover.classList.remove('d-none');
        lastCover ? lastCover === null || lastCover === void 0 ? void 0 : lastCover.classList.add('d-none') : '';
    }
}
